<app-navbar [navClass]="'defaultscroll is-sticky'" [navLight]="true"></app-navbar>

<!-- Hero Section -->
<section class="relative table w-full items-center py-36 bg-[url('/assets/images/bg/cta.jpg')] bg-top bg-no-repeat bg-cover">
  <div class="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/80 to-slate-900"></div>
  <div class="container relative">
    <div class="grid grid-cols-1 pb-8 text-center mt-10">
      <h3 class="text-4xl leading-normal tracking-wider font-semibold text-white">About HarmoNest</h3>
    </div>
  </div>

  <div class="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
    <ul class="tracking-[0.5px] mb-0 inline-block">
      <li class="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out text-white/50 hover:text-white">
        <a [routerLink]="'/'">Home</a>
      </li>
      <li class="inline-block text-base text-white/50 mx-0.5 ltr:rotate-0 rtl:rotate-180">
        <i class="mdi mdi-chevron-right"></i>
      </li>
      <li class="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out text-white" aria-current="page">About Us</li>
    </ul>
  </div>
</section>

<!-- Details Section -->
<div class="container relative md:mt-24 mt-16">
  <div class="grid md:grid-cols-12 grid-cols-1 items-center gap-6 relative">
    <div class="md:col-span-5">
      <div class="relative">
        <img [src]="'assets/images/about.jpg'" class="mx-auto rounded-3xl shadow-[0_30px_40px_rgba(0,0,0,0.5)] dark:shadow-[0_30px_40px_rgba(0,0,0,0.9)] w-[90%]" alt="">

        <div class="absolute flex items-center bottom-3 md:-start-10 -start-5 p-4 rounded-lg shadow-[0_30px_40px_rgba(0,0,0,0.5)] dark:shadow-[0_30px_40px_rgba(0,0,0,0.9)] bg-white dark:bg-slate-900 w-56 m-3">
          <div class="flex items-center justify-center h-[65px] min-w-[65px] bg-red-500/5 text-red-500 text-center rounded-xl me-3">
            <i data-feather="users" class="size-6"></i>
          </div>
          <div class="flex-1">
            <span class="text-slate-400">Happy Guests</span>
            <p class="text-xl font-bold"><span class="counter-value" [countUp]="1200">1200</span>+</p>
          </div>
        </div>

        <div class="absolute flex items-center top-5 md:-end-10 -end-5 p-4 rounded-lg shadow-[0_30px_40px_rgba(0,0,0,0.5)] dark:shadow-[0_30px_40px_rgba(0,0,0,0.9)] bg-white dark:bg-slate-900 w-60 m-3">
          <div class="flex items-center justify-center h-[65px] min-w-[65px] bg-red-500/5 text-red-500 text-center rounded-xl me-3">
            <i data-feather="home" class="size-6"></i>
          </div>
          <div class="flex-1">
            <span class="text-slate-400">Unique Stays</span>
            <p class="text-xl font-bold"><span class="counter-value" [countUp]="20">20</span>+</p>
          </div>
        </div>
      </div>
    </div>

    <div class="md:col-span-7">
      <div class="lg:ms-8">
        <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">
          Welcome to HarmoNest – Your Smart & Cozy Stay in Germany
        </h3>

        <p class="text-slate-400 max-w-xl mb-4">
          At HarmoNest, we believe that travel should feel like coming home. That’s why we’ve built a platform dedicated to short-term stays that prioritize comfort, design, and local connection.
        </p>
        <p class="text-slate-400 max-w-xl mb-4">
          Whether you're exploring Berlin's vibrant streets, attending an event in Düsseldorf, or enjoying a family visit in Stuttgart, our listings are handpicked to offer a consistent, quality experience with every booking.
        </p>
        <p class="text-slate-400 max-w-xl mb-6">
          With 24/7 guest support, a growing portfolio of over 20 uniquely styled apartments, and seamless booking through our platform, HarmoNest is the ideal choice for modern travelers and hosts alike.
        </p>
      </div>
    </div>

    <div class="absolute bottom-0 start-1/3 -z-1">
      <img [src]="'assets/images/map-plane-big.png'" class="lg:w-[600px] w-96 shadow-[0_20px_50px_rgba(0,0,0,0.1)] dark:shadow-[0_20px_50px_rgba(0,0,0,0.5)]" alt="Map and travel graphic">
    </div>
  </div>
</div>

<!-- Team Section -->
<section class="relative md:pb-24 pb-16">
  <div class="container relative md:mt-24 mt-16">
    <div class="grid grid-cols-1 pb-6 text-center">
      <h3 class="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Meet Our Team</h3>
      <p class="text-slate-400 max-w-xl mx-auto">
        Behind HarmoNest is a group of passionate professionals—designers, developers, customer care specialists, and local experts—all working to make your stay unforgettable.
      </p>
    </div>

    <div class="grid md:grid-cols-12 grid-cols-1 mt-8 gap-[30px]">
      <div *ngFor="let item of teamData" class="lg:col-span-3 md:col-span-6">
        <div class="group text-center">
          <div class="relative inline-block mx-auto size-52 rounded-full overflow-hidden">
            <img [src]="item.image" alt="{{item.name}}">
            <div class="absolute inset-0 bg-gradient-to-b from-transparent to-black size-52 rounded-full opacity-0 group-hover:opacity-100 duration-500"></div>
            <ul class="list-none absolute start-0 end-0 -bottom-20 group-hover:bottom-5 duration-500 space-x-1">
              <li class="inline">
                <a [routerLink]="[]" class="size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-md border border-red-500 bg-red-500 text-white">
                  <i data-feather="facebook" class="size-4"></i>
                </a>
              </li>
              <li class="inline">
                <a [routerLink]="[]" class="size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-md border border-red-500 bg-red-500 text-white">
                  <i data-feather="instagram" class="size-4"></i>
                </a>
              </li>
              <li class="inline">
                <a [routerLink]="[]" class="size-8 inline-flex items-center justify-center tracking-wide align-middle duration-500 text-base text-center rounded-md border border-red-500 bg-red-500 text-white">
                  <i data-feather="linkedin" class="size-4"></i>
                </a>
              </li>
            </ul>
          </div>

          <div class="content mt-3">
            <a [routerLink]="[]" class="text-lg font-semibold hover:text-red-500 duration-500">{{item.name}}</a>
            <p class="text-slate-400">Agent</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-client></app-client>
  <app-blog></app-blog>
</section>

<!--<app-image-slider></app-image-slider>-->
<app-footer></app-footer>
<app-switcher></app-switcher>
